import { render, staticRenderFns } from "./my-bindAuth.vue?vue&type=template&id=135a3f60&scoped=true&"
import script from "./my-bindAuth.vue?vue&type=script&lang=js&"
export * from "./my-bindAuth.vue?vue&type=script&lang=js&"
import style0 from "./my-bindAuth.vue?vue&type=style&index=0&id=135a3f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135a3f60",
  null
  
)

export default component.exports